import React from "react";

function Ticket() {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        viewBox="0 0 48 48"
        className="ticket"
        strokeWidth="0.12rem"
      >
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M36.89 24c0-2.917 2.328-5.416 5.61-6.31v-3.095h-37v3.274c2.924 1.012 5.013 3.393 5.013 6.13S8.424 29.12 5.5 30.132v3.273h37V30.31c-3.223-.893-5.61-3.393-5.61-6.31"
        />
        <path
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M13.855 18.048h20.29v11.904h-20.29z"
        />
      </svg>
    </div>
  );
}

export default Ticket;
